import { Component } from 'preact'
import TeamNotesPanel from './TeamNotesPanel'
import { getTeamNote, saveTeamNote, TeamNoteResponse, trackTeamNoteSaved } from './service'

interface Props {
  topicContentType: string
  topicId: string | number
  topicTitle: string
  topicUrl: string
}

interface State {
  contentFromServer: string
  contentInTextarea: string
  updatedBy: string
  updatedAt: string
  showButtons: boolean
  isLoading: boolean
}

class TeamNotes extends Component<Props, State> {
  private readonly topicId: number

  constructor (props: Props) {
    super()
    this.topicId = Number(props.topicId)
    this.state = {
      contentFromServer: '',
      contentInTextarea: '',
      updatedBy: '',
      updatedAt: '',
      showButtons: false,
      isLoading: false
    }
    this.onContentChange = this.onContentChange.bind(this)
    this.onTextareaFocus = this.onTextareaFocus.bind(this)
    this.onSaveChanges = this.onSaveChanges.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

  async componentDidMount () {
    try {
      const res = await getTeamNote(this.topicId)
      this.handleResponse(res)
    } catch {}
  }

  handleResponse (response: TeamNoteResponse) {
    const { content, updatedBy, updatedAt } = response
    this.setState({
      contentFromServer: content,
      contentInTextarea: content,
      updatedBy: updatedBy,
      updatedAt: updatedAt
    })
  }

  onContentChange (value: string) {
    this.setState({ contentInTextarea: value })
  }

  onTextareaFocus () {
    if (!this.state.showButtons) {
      this.setState({ showButtons: true })
    }
  }

  async onSaveChanges () {
    const { topicContentType, topicTitle, topicUrl } = this.props
    const { contentInTextarea } = this.state

    this.setState({ isLoading: true })

    try {
      const res = await saveTeamNote(this.topicId, contentInTextarea)
      this.handleResponse(res)
      trackTeamNoteSaved(topicContentType, this.topicId, topicTitle, topicUrl)
    } catch {}

    this.setState({
      showButtons: false,
      isLoading: false
    })
  }

  onCancel () {
    this.setState({
      contentInTextarea: this.state.contentFromServer,
      showButtons: false
    })
  }

  render () {
    const { contentInTextarea, isLoading, updatedBy, updatedAt, showButtons } = this.state
    return (
      <TeamNotesPanel
        updatedBy={updatedBy}
        updatedAt={updatedAt}
        contentInTextarea={contentInTextarea}
        showButtons={showButtons}
        isLoading={isLoading}
        onContentChange={this.onContentChange}
        onTextareaFocus={this.onTextareaFocus}
        onSaveChanges={this.onSaveChanges}
        onCancel={this.onCancel}
      />
    )
  }
}

export default TeamNotes
